module.exports = __webpack_public_path__ + "gb-eng.1d353c89b3209c481194.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gb-eng.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gb-eng.svg
// module chunks = styles